/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unused-vars */
import { Fragment, useState } from 'react';
import { Menu, Transition } from '@headlessui/react';
import {
  HiOutlineBell,
  HiOutlineMenuAlt2,
} from 'react-icons/hi';
import { IoSearch } from 'react-icons/io5';
import { IoIosArrowDown } from 'react-icons/io';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from '../../assets/images/LogoSimpleMRI.svg';
import { useGetProfileQuery, mriPatientApi } from '../../services/api';
import {
  classNames, isUserLoggedIn, getUserDetails,
} from '../../utils';
import { handleSidebarOpen } from '../../redux/layout';

export default function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { data: user, isLoading } = useGetProfileQuery({ id: getUserDetails()?._id });

  const logout = () => {
    // temporary function just to see the UI functionality
    localStorage.removeItem('token');
    localStorage.removeItem('booking');
    sessionStorage.clear();
    localStorage.removeItem('user');
    dispatch(mriPatientApi.util.resetApiState());

    navigate('/login');
  };

  const loggedUserNavigation = [
    { name: 'My Profile', onClick: () => navigate('/profile') },
    { name: 'Book Now', onClick: () => navigate('/choose-location') },
    { name: 'My Appointments', onClick: () => navigate('/appointments') },
    // { name: 'FAQs', onClick: () => navigate('/faqs') },
    { name: 'FAQs', onClick: () => window.open('https://www.simplemri.com/frequently-asked-questions', '_self') },
    { name: 'Refund Policy', onClick: () => navigate('/refund-policy') },
    { name: 'Sign out', onClick: () => logout() },
  ];

  const guestUserNavigation = [
    { name: 'Login', onClick: () => navigate('/login') },
    { name: 'Register', onClick: () => navigate('/register') },
    // { name: 'FAQs', onClick: () => navigate('/faqs') },
    { name: 'FAQs', onClick: () => window.open('https://www.simplemri.com/frequently-asked-questions', '_self') },
    { name: 'Refund Policy', onClick: () => navigate('/refund-policy') },
    { name: 'Terms & Conditions', onClick: () => navigate('/terms-and-conditions') },
  ];

  const [activeLang, setActiveLang] = useState('en');

  return (
    <div className={`sticky top-0 z-20 flex font-[Poppins] justify-between h-18 px-6  lg:px-[8.5rem] bg-white z-20 relative ${location.pathname === '/' ? 'hidden' : ''}`}>
      {/* <button
        type="button"
        className="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
        onClick={() => dispatch(handleSidebarOpen(true))}
      >
        <span className="sr-only">Open sidebar</span>
        <HiOutlineMenuAlt2 className="h-6 w-6" aria-hidden="true" />
      </button> */}
      {/* <div className="py-3 mt-1 cursor-pointer" onClick={() => navigate('/')}> */}
      <div className="py-3 mt-1 cursor-pointer" onClick={() => { window.location.href = 'https://www.simplemri.com/'; }}>
        {/* ----logo-------- */}
        <img src={logo} alt="379MRI" className="md:h-12 transition-width duration-300" />
        {/* <p className="text-center">POWERED BY DOCTORFARE</p> */}
      </div>
      <div className=" px-4 text-[1.5rem] flex justify-between items-center text-black font-medium">
        <div className="flex-1 flex" />
        <div className="ml-4 flex items-center gap-2 md:ml-6">
          {location.pathname !== '/choose-location' && <p className="cursor-pointer hidden md:block text-sm" onClick={() => navigate('/choose-location')}>Search</p>}
          {location.pathname !== '/choose-location' && <IoSearch className="text-primary-500 cursor-pointer" title="Search" onClick={() => navigate('/choose-location')} />}

          {/* Profile dropdown */}
          <Menu as="div" className="ml-3 relative items-center">
            {/* <select className="border-none py-0">
              <option value={isUserLoggedIn() ? user?.firstName : 'Guest'}>{isUserLoggedIn() ? user?.firstName : 'Guest'}</option>
            </select> */}
            <div>
              <Menu.Button className="max-w-md flex items-center text-sm rounded-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 px-2 py-1">
                <span className="sr-only">Open user menu</span>
                <span className="mr-3 capitalize hidden md:block">{isUserLoggedIn() ? user?.fullName : 'Guest'}</span>
                <span className="mr-3 capitalize block md:hidden">{isUserLoggedIn() ? user?.firstName : 'Guest'}</span>
                <span><IoIosArrowDown /></span>

                {/* <img
                  className="h-8 w-8 rounded-full"
                  src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                  alt=""
                /> */}
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                {(isUserLoggedIn() ? loggedUserNavigation : guestUserNavigation).map((item) => (
                  <Menu.Item key={item.name}>
                    {({ active }) => (
                      <button
                        onClick={item.onClick}
                        className={classNames(
                          active ? 'bg-gray-100' : '',
                          'block px-4 py-2 text-sm text-gray-700 w-full text-left',
                        )}
                      >
                        {item.name}
                      </button>
                    )}
                  </Menu.Item>
                ))}
              </Menu.Items>
            </Transition>
          </Menu>

          {/* ---language toggle------- */}
          {/* <div className="bg-white rounded-full p-2 flex items-center gap-1">
            <button className={`btn  ${activeLang === 'en' ? 'bg-secondary-500 text-white hover:bg-secondary-500' : 'text-secondary-500  bg-white hover:bg-white'} rounded-full text-sm p-1 md:px-2`} onClick={() => setActiveLang('en')}>EN</button>
            <button className={`btn  ${activeLang === 'es' ? 'bg-secondary-500 text-white hover:bg-secondary-500' : 'text-secondary-500 bg-white hover:bg-white'} rounded-full text-sm p-1 md:px-2`} onClick={() => setActiveLang('es')}>ES</button>
          </div> */}

          <button
            type="button"
            className="p-1 rounded-full hidden md:block text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ml-1"
          >
            <span className="sr-only">View notifications</span>
            <HiOutlineBell className="h-6 w-6 text-secondary-500" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
}
